<div class="card">
  <div class="card-header">
    <h3>{{ titulo }}</h3>
    <h5>Total: {{ total }}</h5>
  </div>
  <div class="card-body">
    <div class="chart-wrapper">
      <div class="values-above-chart">
        <div class="y-axis-space"></div>
        <div class="value-item" *ngFor="let elemento of elementos">
          @if(elemento.label !== '') {
            <p>{{ elemento.valor }} <span>({{ elemento.percentual }}%)</span></p>
          }
        </div>
      </div>
      <div class="chart-container">
        <canvas
          baseChart
          #barChart
          [data]="barChartData"
          [options]="barChartOptions"
          [type]="barChartType">
        </canvas>
      </div>
    </div>
  </div>
</div>
